<template>
	<div id="createCertificate">

		<div class="removePolygonsToolHints">
			<span>
				<!-- eslint-disable-next-line -->
				Draw a polygon using the polygon tool ( <font-awesome-icon icon="draw-polygon"> </font-awesome-icon> )
				and use the cut tool ( <font-awesome-icon icon="cut"> </font-awesome-icon> ) to mark the areas you want
				to remove from the first polygon ( <font-awesome-icon icon="draw-polygon"> </font-awesome-icon> ).
				<br />
				Use the clean tool ( <font-awesome-icon icon="snowplow"> </font-awesome-icon> ) to clean everything and
				start over.
			</span>

			<span>
				{{ removePolygonsToolMsg }}
			</span>

			<!-- eslint-disable-next-line -->
			<button class="btnbtn" v-if="geoPointsDrawn.cutMode.length > 0" @click="onProcessMasks">
				Cut the marked regions
			</button>
		</div>

		<mapbox
			:accessToken="mapOptions.accessToken"
			:map-options="mapOptions"
			@map-init="mapInitialized"
			:nav-control="{ show: true, position: 'bottom-right' }"
			:scale-control="{ show: true, position: 'bottom-left' }"
			:fullscreen-control="{ show: false, position: 'top-left' }"
			>
		</mapbox>

		<div id="formBox" class="flex-col">
			<div class="calculation-box">
				<p v-if="!areaInM2">
					<!-- eslint-disable-next-line -->
					Use the polygon tool ( <font-awesome-icon icon="draw-polygon"> </font-awesome-icon> ) to see the
					area of the land.
				</p>
				<div id="calculated-area" v-if="areaInM2">
					Selected {{ formatCalculatedArea(calculateAreaInM2(false, $store.state.globalSettings.AREA_UNIT)) }}
				</div>
			</div>

			<div class="pt-2">
				<form>
					<div class="md:flex md:items-center mb-6">
						<div class="md:w-1/3">
							<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
								Product
							</label>
						</div>

						<div class="md:w-1/3">
							<vue-multiselect
								placeholder="Type the product name to begin search"
								:options="productLookupOptions"
								label="label"
								v-model="formData.Product"
								:filterable="false"
								>
							</vue-multiselect>
						</div>
					</div>

					<div class="md:flex md:items-center mb-6">
						<div class="md:w-1/3">
							<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
								Producer
							</label>
						</div>

						<div class="md:w-1/3">
							<vue-multiselect
								:options="producerLookupOptions"
								v-model="formData.producerSelected"
								placeholder="Type the producer's NOP operation ID or operation name to begin search."
								:internalSearch="false"
								@search-change="searchProducers"
								label="label"
								@change="onProducerChange"
								>
							</vue-multiselect>
						</div>
					</div>

					<div class="md:flex md:items-center mb-6">
						<div class="md:w-1/3">
							<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
								Issued on
							</label>
						</div>

						<div class="md:w-1/3 datePickerDiv">
							<v-datepicker
								v-model="formData.IssuedOn"
								:clear-button="true"
								placeholder="Certificate issued on"
							></v-datepicker>
						</div>
					</div>

					<div class="md:flex md:items-center mb-6">
						<div class="md:w-1/3">
							<label class="block text-black md:text-right mb-1 md:mb-0 pr-4">
								Comments
							</label>
						</div>

						<div class="md:w-1/3">
							<textarea
								style="border:solid 1px #dae1e7"
								class="w-full"
								v-model="formData.Comments"
							></textarea>
						</div>
					</div>

					<button @click="onSubmitForm" type="submit">
						Submit
					</button>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import Mapbox from "mapbox-gl-vue";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import TurfArea from "@turf/area";

import { ConvertFromM2To } from "../../utils/areaConverter.js";
import { MapCutMode } from "../../components/CustomMapBoxDrawModes/MapCutMode.js";
import { BasePolygonMode } from "../../components/CustomMapBoxDrawModes/BasePolygonMode.js";
import { CustomDirectSelectMode } from "../../components/CustomMapBoxDrawModes/CustomDirectSelectMode.js";

import polybooljs from "polybooljs";

import StylesSpec from "../../components/CustomMapBoxDrawModes/StylesSpec.js";
import asyncRequest from "./../../utils/asyncRequest.js";

import { deleteEverythingButton, cutButton, basePolyButton } from "./MapBoxButtons.js";

var _get = require("lodash.get");

export default {
	name: "CreateLandRegisterView",
	created() {
		this.stillDrawing = true
		this.findAllProducts();
	},
	mounted() {
		this.stillDrawing = true
	},
	data() {
		return {
			//This var is used to makesure when the window is drawn it doesn't flicker, remember the issue
			//Where when you first go to the site, it draws the map tool first and then redirects you to the login
			//page. This is to prevent that map from appearing whe we are being redirected
			stillDrawing:true,
			productLookupOptions: [],

			producerLookupOptions: [],
			removePolygonsToolMsg: "",
			formData: {
				Product: "",
				LandAreaGPS: "",
				Unit: "kilogram",
				producerSelected: "",
				LandMarkedGEOJson: ""
			},
			areaInM2: null,
			areaCalculated: "",
			convertedAreaVal: "",
			convertedAreaSI: "",
			//mapbox-gl-draw object
			Draw: {},
			//Mapbox options
			mapOptions: {
				accessToken:
				"pk.eyJ1IjoibWFsaWtmb3V6ZSIsImEiOiJjanF6ZHU2ZHowZDF1NDNsazl6dWF2OXoxIn0.7ZmKrMF5juUPgm2QS6RpsQ",
				style: "mapbox://styles/malikfouze/cjqzfa3r72dku2sljvm9d0sks",
				center: [-106.39640808105469, 52.276245566098574],
				//center: [-106.657807, 52.136847], //Sunrise building
				zoom: 13
			},
			geoPointsDrawn: {
				polygons: [],
				cutMode: []
			}
		};
	},
	methods: {
		//Product lookup
		findAllProducts() {
			asyncRequest.ServerAPI({
				method: "GET",
				api: this.$store.state.urls.GET_ALL_PRODUCTS,
				onSuccessCallback: dataIn => {
					this.reorganizeProductLookupData(dataIn);
				},
				postData: null,
				flags: asyncRequest.M_FAIL,
				customSuccessMessage: "",
				customErrorMessage: "",
				beforeAfterCallback: false
			});
		},
		reorganizeProductLookupData(dataIn) {
			if (!Array.isArray(dataIn.Data)) {
				this.productLookupOptions = [];
				return;
			}
			this.productLookupOptions = [];
			var d = dataIn.Data;

			for (var i = 0; i < d.length; i++) {
				this.productLookupOptions.push({
					value: d[i].ProductID,
					label: d[i].ProductName
				});
			}
		},
		formatCalculatedArea(areaCalculated) {
			return areaCalculated.val + " " + areaCalculated.unit;
		},

		//Attaches the geocoder and the draw controls in to our map
		mapInitialized(mapIn) {
			//Add the geo coder
			mapIn.addControl(
			new MapboxGeocoder({
					accessToken: this.mapOptions.accessToken
				})
			);

			//Init and add draw controls
			this.Draw = new MapboxDraw({
				userProperties: true,
				displayControlsDefault: false,
				styles: StylesSpec.mapStyleSpec,
				touchEnabled: true,
				modes: Object.assign(
					{
						map_cut_mode: MapCutMode,
						base_polygon_draw: BasePolygonMode,
						custom_direct_select_mode: CustomDirectSelectMode
					},
					MapboxDraw.modes
				),
				//Define which controls are shown for the draw tools
				controls: {
					polygon: false,
					trash: true,
					line_string: false,
					point: false,
					combine_features: false,
					uncombine_features: false
				}
			});

			//Decide where to draw this thing
			mapIn.addControl(this.Draw, "top-left");

			//Add event listeners for the events emitted from the draw modes.
			//Event handlers to catch everything else
			mapIn.on("draw.create", this.onAddProxy);
			mapIn.on("draw.delete", this.onDeleteProxy);
			mapIn.on("draw.update", this.onUpdateProxy);

			//Event handlers for map_cut_mode
			mapIn.on("map_cut_mode.create", this.onPolygonmaskDraw);
			mapIn.on("map_cut_mode.found_intersection", this.onDrawMaskFindIntersections);

			//Event handlers for base_polygon_draw
			mapIn.on("base_polygon_draw.create", this.onAddProxy);
			mapIn.on("base_polygon_draw.found_intersection", this.onDrawMaskFindIntersections);
			mapIn.on("base_polygon_draw.polygonDrawn", this.onPolygonDrawn);

			mapIn.on("draw.modechange", this.onDrawModeChange);

			//Delete everything  button
			//map_cut_mode_button
			//base_polygon_mode_button
			var delButton = deleteEverythingButton;
			var cutBtn = cutButton;
			var basePolyBtn = basePolyButton;

			document.addEventListener("delete_everything_button.clicked", this.onDeleteEverythingButtonClicked);
			document.addEventListener("map_cut_mode_button.clicked", this.onCutModeButtonClicked);
			document.addEventListener("base_polygon_draw_button.clicked", this.onBasePolyDrawButtonClicked);

			var firstChild = document.getElementsByClassName("mapboxgl-ctrl-group")[0].childNodes[0];
			//Add in reverse order becasue we keep adding to top so
			document.getElementsByClassName("mapboxgl-ctrl-group")[0].insertBefore(basePolyBtn, firstChild);
			document.getElementsByClassName("mapboxgl-ctrl-group")[0].insertBefore(cutBtn, firstChild);
			document.getElementsByClassName("mapboxgl-ctrl-group")[0].appendChild(delButton);
		},

		//We need to makesure the user can draw ONLY one base polygon ?? or countless?
		onBasePolyDrawButtonClicked() {
			//Only allow when there's nothing drawn using the base polygon
			if (this.geoPointsDrawn.polygons.length == 0) {
				this.Draw.changeMode("base_polygon_draw");
			} else {
			this.$store.commit("notifications/changeNotificationModalState", {
					message: "Sorry. You can only draw one base polygon. Use the clean everything tool to start over.",
					type: "error"
				});
			}
			return true;
		},
		onCutModeButtonClicked() {
			var polLen = this.geoPointsDrawn.polygons.length;

			if (polLen == 0) {
			this.$store.commit("notifications/changeNotificationModalState", {
					message: "Sorry. You need to first draw a polygon using the polygon tool before you can cut.",
					type: "error"
				});
			} else if (polLen > 0) {
				this.Draw.changeMode("map_cut_mode");
				this.removePolygonsToolMsg = " ";
			} else {
				this.removePolygonsToolMsg = "Unknown error. please refresh the page.";
			}
			return true;
		},
		onDeleteEverythingButtonClicked() {
			//Notw when calling this we saw some weird error abt the ctx inside the draw obj is null, not i canr reproduce it lol
			this.Draw.deleteAll();
			this.geoPointsDrawn = {
				polygons: [],
				cutMode: []
			};

			this.$store.commit("notifications/changeNotificationModalState", {
				message: "Cleared.",
				type: "success",
				position: "topCenter"
			});
		},
		//Search for producers
		searchProducers(searchQry) {
			if (!searchQry) {
				return;
			}

			var URL = this.$store.state.urls.GET_PRODUCER_BY_OP_NAME_BY_CERTIFIER_ID + searchQry + "/";
			//this is a deep copy to makesure no one messes with my original search query
			var tmp = ("" + searchQry).replace(/ /g, "");
			//figure which method to call, if number its nop, if not, then searching by name
			if (Number.isInteger(Number(tmp))) {
				URL = this.$store.state.urls.GET_PRODUCER_BY_NOP_ID + tmp + "/";
			}
			asyncRequest.ServerAPI({
				progressBarObj: this.$Progress,
				method: "GET",
				api: URL,
				onSuccessCallback: dataIn => {
					this.reorganizeProducerLookupData(dataIn);
				},
				flags: asyncRequest.M_FAIL,
				beforeAfterCallback: false
			});
		},
		//Once we find the producers reorg the data to something vue-select can understand
		reorganizeProducerLookupData(dataIn) {
			if (!Array.isArray(dataIn.Data)) {
				this.producerLookupOptions = [];
				return;
			}

			this.producerLookupOptions = [];
			var d = dataIn.Data;
			for (var i = 0; i < d.length; i++) {
				var t = JSON.parse(JSON.stringify(d[i]));

				var l = d[i].NOPID + " : " + d[i].OpName;
				t.opIdNameLabel = l;

				if (d[i].City || d[i].Country) {
					t.countryLabel = " (" + d[i].City + " - " + d[i].Country + ")";
					l += t.countryLabel;
				}

				//For the producer we track them by their allop id
				t.value = d[i].AllOperationsID;
				t.label = l;

				this.producerLookupOptions.push(t);
			}
		},
		onProducerChange(e) {
			e.preventDefault();
		},
		onPolygonDrawn() {
			try {
				this.calculateAreaInM2(false, this.$store.state.globalSettings.AREA_UNIT);
				this.formData.LandMarkedGEOJson = this.Draw.getAll().features[0].geometry;
			} catch (e) {
				//eslint-disable-next-line
				console.log("Error when drawing a ploygon::::> " + e);
			}
		},
		//Once a user draws the base poly and the mask/cut we get this method to cut pieces for us.
		onProcessMasks() {
			var currPoly = {};
			try {
				var resolvedPolygons = [];
				//For each base polygon
				//find the intersections, with the base poly, and the cur polys
				//substract it and then produce new poly
				for (var i = 0; i < this.geoPointsDrawn.polygons.length; i++) {
					currPoly = polybooljs.polygonFromGeoJSON(this.geoPointsDrawn.polygons[i].geometry);
					for (var j = 0; j < this.geoPointsDrawn.cutMode.length; j++) {
						var currPolyMask = polybooljs.polygonFromGeoJSON(this.geoPointsDrawn.cutMode[j].geometry);

						var intersect = polybooljs.intersect(currPolyMask, currPoly);

						//if there is no intersection then we dont need to bother abt this one
						if (intersect == null || intersect.regions.length == 0) {
							continue;
						}
						//if there is an intersect then find the difference
						var difference = polybooljs.difference(currPoly, intersect);

						currPoly = difference;
					}
					resolvedPolygons.push({
						geometry: polybooljs.polygonToGeoJSON(currPoly)
					});
				}

				//Now that we have done our job, time to clean out the old polygons and add our polygon we just created
				this.Draw.deleteAll();
				this.Draw.add(resolvedPolygons[0].geometry);
				this.formData.LandMarkedGEOJson = resolvedPolygons[0].geometry;
				//Set the current main polygon to the one we just created
				this.geoPointsDrawn.polygons = [];
				//We are not doing resolvedPolygons[0] and instead doing a this.Draw.getAll() becuase otherwsie we dont get the id righ
				this.geoPointsDrawn.polygons = [this.Draw.getAll().features[0]];
				//clear all the polygons that helped us cut the main polygon
				this.geoPointsDrawn.cutMode = [];

				// passing a false in here to let this func know we just want an update to the vals.
				this.calculateAreaInM2(false, this.$store.state.globalSettings.AREA_UNIT);
			} catch (e) {
				//eslint-disable-next-line
				console.warn("-------------err-------------------");
				//eslint-disable-next-line
				console.warn(e);
				//eslint-disable-next-line
				console.warn("this.geoPointsDrawn.cutMode", this.geoPointsDrawn.cutMode);
				//eslint-disable-next-line
				console.warn("this.geoPointsDrawn.polygons", this.geoPointsDrawn.polygons);
				//eslint-disable-next-line
				console.warn("currPoly", currPoly);
				//eslint-disable-next-line
				console.warn("-------------err-------------------");
			}
			//So we need to do the following.
			//A) get all the mask polygons
			//B) get all the non mask polygons

			//For each
			//non mask polygon you have, in afor loop take a mask polygon . Tehn test for intersections
			//Once you have the intersections, use that to find the mask.

			//We need to maesure we intersect first and then test the mnask, coz otherwse in a situation the user drew the
			//mask outside the main polygin, then we need to makesure we are dealing with only the inner parts of the mask.

			//If the intersection is null, then we are not even going to bother to mask this thing.

			//we like good old forloops around here

			//lets try something new lets first combine out normal polygons
		},
		//mapIn.on("map_cut_mode.found_intersection", this.onDrawMaskFindIntersections);
		onDrawMaskFindIntersections(e) {
			var fillColor = StylesSpec.extraStyleSettings.cutTool_Active_FillColor_when_hasNoIntersect;

			if (e.hasSelfIntersections) {
				fillColor = StylesSpec.extraStyleSettings.cutTool_Active_FillColor_when_hasIntersect;
			}

			this.Draw.setFeatureProperty(e.features[0].properties.id, "polygon_fill_color_active_inactive", fillColor);
		},
		//When the user completes drawing the polygon call this.
		//it sets colors depending if the polygon has intersections or no intersections.
		onPolygonmaskDraw(infoIn) {
			var fillColor = StylesSpec.extraStyleSettings.cutTool_FillColor_when_finished;
			var borderColor = StylesSpec.extraStyleSettings.cutTool_StrokeColor_when_finished;

			if (infoIn.hasSelfIntersections) {
				fillColor = StylesSpec.extraStyleSettings.cutTool_Active_FillColor_when_hasIntersect;
				borderColor = StylesSpec.extraStyleSettings.cutTool_Active_StrokeColor_when_hasIntersect;
			}
			this.Draw.setFeatureProperty(infoIn.features[0].id, "polygon_fill_color_active_inactive", fillColor);
			this.Draw.setFeatureProperty(infoIn.features[0].id, "polygon_stroke_inactive", borderColor);

			this.geoPointsDrawn.cutMode.push(infoIn.features[0]);
		},
		onDeleteProxy(infoIn) {
			this.findPolygonAndDelete(infoIn, "polygons");
			this.findPolygonAndDelete(infoIn, "cutMode");

			this.calculateAreaInM2(null, this.$store.state.globalSettings.AREA_UNIT);
		},
		onUpdateProxy(infoIn) {
			this.findPolygonAndUpdate(infoIn, "polygons");
			this.findPolygonAndUpdate(infoIn, "cutMode");
			this.calculateAreaInM2(null, this.$store.state.globalSettings.AREA_UNIT);

			this.formData.LandMarkedGEOJson = this.Draw.getAll().features[0].geometry;
		},
		onAddProxy(infoIn) {
			this.calculateAreaInM2(infoIn, this.$store.state.globalSettings.AREA_UNIT);
		},
		//This function goes through our polygons we are keeping track of and updates them when they get updated.
		findPolygonAndUpdate(geoIn, key) {
			if (key != "polygons" && key != "cutMode") {
				throw "HAS to be polygons or cutMode";
			}

			//Lets try and see if we can find an object with this id.
			var loopingArr = this.geoPointsDrawn[key];

			var searchStatus = { idx: -1, found: false };
			for (var i = 0; i < loopingArr.length; i++) {
				if (loopingArr[i].id == geoIn.features[0].id) {
					searchStatus = { idx: i, found: true };
				}
			}

			//Ohh we found it, so just update it.
			if (searchStatus.found) {
				this.geoPointsDrawn[key][searchStatus.idx] = {};
				this.geoPointsDrawn[key][searchStatus.idx] = geoIn.features[0];
			}
		},
		findPolygonAndDelete(geoIn, key) {
			if (key != "polygons" && key != "cutMode") {
				throw "HAS to be polygons or cutMode";
			}

			//Lets try and see if we can find an object with this id.
			var loopingArr = this.geoPointsDrawn[key];

			var searchStatus = { idx: -1, found: false };
			for (var i = 0; i < loopingArr.length; i++) {
				if (loopingArr[i].id == geoIn.features[0].id) {
					searchStatus = { idx: i, found: true };
				}
			}

			//Ohh we found it, so just delete it.
			if (searchStatus.found) {
				this.geoPointsDrawn[key].splice(searchStatus.idx,1);
			}
		},
		//unit in is optional. the 2 in the func name is squared lolololol.
		calculateAreaInM2(infoIn, unitIn) {
			//If the thing that got it drawn just now is a polygon then save its id we need it later to do math with lol
			if (
				infoIn &&
					infoIn.features[0] &&
					infoIn.features[0].geometry &&
					infoIn.features[0].geometry.type == "Polygon"
			) {
				this.geoPointsDrawn.polygons.push(infoIn.features[0]);
			}
			//get the data from mapbox draw
			var data = this.Draw.getAll();

			//Get turf to calculate the area in m2 using the gps coordinates we gave it
			this.areaInM2 = parseFloat(TurfArea(data));

			//If there is no area to be calculated
			if (this.areaInM2 < 1) {
				this.areaInM2 = "";
			}

			if (!unitIn) {
				unitIn = this.$store.state.globalSettings.AREA_UNIT;
			}
			var ret = this.calculateWithUnits(this.areaInM2, unitIn);

			this.areaCalculated = ret;
			return ret;
		},
		calculateWithUnits(valInM2, unit) {
			var convertedData = ConvertFromM2To(unit, valInM2);
			//If this func returns nothing
			if (convertedData == 0) {
				this.convertedAreaVal = "";
				return;
			}
			this.convertedAreaVal = convertedData.areaInConvertedUnit;
			this.convertedAreaSI = convertedData.unitConvertedToSI;

			return { val: this.convertedAreaVal, unit: this.convertedAreaSI };
		},
		onSubmitForm() {
			var URL = this.$store.state.urls.POST_ADD_NEW_CERTIFICATE;

			var LandMarkedGEOJson = _get(this.formData, "LandMarkedGEOJson", "");

			LandMarkedGEOJson = LandMarkedGEOJson ? JSON.stringify(LandMarkedGEOJson) : "";

			//We are not sending things like userid certifier id, they should be figured out by the server non of our
			//business herer in the ui
			var dataToPost = {
				CertificateIssuedToID: _get(this.formData, "producerSelected.value", 0),
				LandMarkedGEOJson: LandMarkedGEOJson,
				IssuedOn: _get(this.formData, "IssuedOn", null),
				ProductID: _get(this.formData, "Product.value", 0)
			};

			asyncRequest.ServerAPI({
				progressBarObj: this.$Progress,
				method: "POST",
				api: URL,
				postData: dataToPost,
				onSuccessCallback: dataIn => {
					this.onSuccessfulSubmitForm(dataIn);
				},
				flags: asyncRequest.M_FAIL | asyncRequest.M_SUCCESS,
				beforeAfterCallback: false
			});
		},
		onSuccessfulSubmitForm(dataIn) {
			this.$router.push({ name: "view-land-record", params: { id: dataIn.Data }})
		},
		onDrawModeChange() {
			if (this.Draw) {
				//Helps us decide what msg to show our user when they select this
				if (this.Draw.getMode() != "map_cut_mode" && this.geoPointsDrawn.cutMode.length == 0) {
					this.removePolygonsToolMsg = "";
				}
				if (this.Draw.getMode() == "direct_select") {
				this.Draw.changeMode("custom_direct_select_mode", {
						featureId: this.Draw.getSelected().features[0].id
					});
				}
			}
		},
		onProductTypeChange() {},
		onWeightUnitChange() {}
	},
	components: { Mapbox }
};
</script>

<style>
#createCertificate .mapboxgl-canvas {
	position: inherit !important;
}
#createCertificate {
	padding-right: 2%;
	padding-left: 2%;
}
#createCertificate #map {
	height: 65vh;
	margin-top: -16px;
}
#createCertificate .calculation-box {
	height: 75px;
	bottom: 490px;
	left: 10px;
	background-color: #fff;
	padding: 15px;
	text-align: center;
	padding-top: 30px;
}
#createCertificate p {
	margin: 0;
	font-size: 16px;
}
#createCertificate #formBox {
	border-width: 1px;
	background-color: #fff;
	padding-bottom: 10px;
	padding-right: 5px;
	padding-left: 5px;
}
#createCertificate .removePolygonsToolHints {
	color: #000;
	font-size: 18px;
	font-weight: 400;
	background-color: #fff;
	text-align: center;
	height: 100%;
	line-height: 32px;
	border: 1px solid #dae1e7;
	padding-top: 20px;
	padding-bottom: 35px;
}
#createCertificate .removePolygonsToolHints span {
	display: line-block;
	vertical-align: middle;
	line-height: normal;
}
#createCertificate .btnbtn {
	background-color: #f9d01c;
	border: 1px solid #f1f1f1;
	color: #000;
}
#createCertificate .btnbtn:hover {
	background-color: #fbd01f;
	border: 1px solid #f1f1f1;
	color: #000;
}
#createCertificate .datePickerDiv input {
	border: 1px solid #dae1e7;
	width: 100%;
	height: 100%;
	padding-left: 12px;
	height: 33px;
}
</style>
